/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsNewConversation
 */
export interface WsNewConversation {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsNewConversation
     */
    type: string | null;
    /**
     * The conversation ID
     * @type {string}
     * @memberof WsNewConversation
     */
    conversationId: string;
}

/**
 * Check if a given object implements the WsNewConversation interface.
 */
export function instanceOfWsNewConversation(value: object): value is WsNewConversation {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function WsNewConversationFromJSON(json: any): WsNewConversation {
    return WsNewConversationFromJSONTyped(json, false);
}

export function WsNewConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsNewConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'conversationId': json['conversation_id'],
    };
}

export function WsNewConversationToJSON(json: any): WsNewConversation {
    return WsNewConversationToJSONTyped(json, false);
}

export function WsNewConversationToJSONTyped(value?: WsNewConversation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'conversation_id': value['conversationId'],
    };
}

